module.exports = __webpack_public_path__ + "img/112.ede8049b.png";